import { useState } from 'react';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import IButton from '../../../components/button/i-button.component';

const FileUpload = (props: any) => {
  const [selectedFile, setSelectedFile] = useState<any>();

  const handleFileChange = (event: any) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = () => {
    props.uploadFile(selectedFile);
  }

  const getMainPanel = () => {
    return (
      <div>
        <input type="file" onChange={handleFileChange} />
        <IButton label='Upload' onActionEvent={handleUpload}/>
      </div>
    );
  }

  return <TitlePanel title='' panelBody={getMainPanel()} />
}

export default FileUpload;